import { render, staticRenderFns } from "./fileLoader.vue?vue&type=template&id=3bd4d33f&scoped=true&"
import script from "./fileLoader.vue?vue&type=script&lang=js&"
export * from "./fileLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd4d33f",
  null
  
)

export default component.exports